import { render, staticRenderFns } from "./CollapsiblePane.vue?vue&type=template&id=41413187&"
import script from "./CollapsiblePane.vue?vue&type=script&lang=js&"
export * from "./CollapsiblePane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports